export default {
  walletSetting: {
    title: "Wallet Settings",
    assetsType: "Display Assets in:",
    nameType: "Display Currency Names in:",
    saveButton: "Save Changes",
    cancelButton: "View",
    assetsTypeList: [
      {
        value: "IRR",
        title: "Rial (IRR)"
      },
      {
        value: "USDT",
        title: "Dollar ($)"
      }
    ],
    nameTypeList: [
      {
        value: "name_locale",
        title: "Persian"
      },
      {
        value: "name",
        title: "English"
      }
    ]
  },
  walletHero: {
    allAssetsValue: "Total Asset Value",
    totalProfitLoss: "Total Profit (Loss)",
    deposit: "Deposit",
    withdrawal: "Withdraw",
    exchange: "Exchange",
    transfer: "Transfer",
    otherCurrencies: "Other Currencies",
    showAssets: "Show Assets",
    hideAssets: "Hide Assets"
  },
  walletTable: {
    searchInput: "Search by currency name or symbol...",
    hideZeroAssets: "Hide Zero Assets",
    returnToInitialSettings: "Return to Initial Settings",
    tableLayout: "Table Layout",
    tableSetting: "Settings",
    rowPerPage: "Rows per Page",
    to: "to",
    of: "of",
    symbol: "Currency Name",
    name: "Name",
    totalAsset: "Asset",
    blockedAsset: "Blocked Asset",
    availableAsset: "Available Asset",
    currentValue: "Current Value (IRR)",
    averagePurchasePrice: "Average Purchase Price",
    profitLoss: "Profit / Loss",
    profitLossRate: "Profit / Loss (IRR)",
    assetPercentageFromTotal: "Percentage of Total Asset",
    operation: "Operation",
    update: "Update"
  },
  checkMarketTerms: {
    traderTermsDesc:
      "Dear user, to work with the Excoino Market section, you must first accept the rules of this section. To do this, first go to the Excoino Market section, read and accept the rules, then return to this page to transfer the cryptocurrency.",
    goToTrader: "Go to Excoino Market"
  },
  operationsInTable: {
    deposit: "Deposit",
    withdraw: "Withdraw",
    exchange: "Exchange",
    transfer: "Transfer"
  },
  noRowsTemplate: {
    noCurrenciesFound: "No currencies found"
  },
  notLoading: {
    loading: "Loading"
  }
};
